import { useEffect, useState } from 'react'
import Graytextarea from '../../../components/Graytextarea'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const RiskfactorsFreeTypeRecords = ({ patientDBdata, isSavingTheData, diagnosisName, patientID, MasterDiagnosisData, loggedUserProvider, setPatientDBdata, noteID,noteActualId }) => {
    const [riskfactors, setRiskfactors] = useState('')
    const [tempRiskfactors, setTempRiskfactors] = useState('')
    const [addedThruUseeffect, setAddedThruUseEffect] = useState(false)

    useEffect(()=>{
        if(!riskfactors) return

        if (addedThruUseeffect) {
            setAddedThruUseEffect(false)
            return;
        }

        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        freeTypesEverything: {
                            ...prev?.currentNote?.data?.freeTypesEverything,
                            riskfactors:{
                                ...prev?.currentNote?.data?.freeTypesEverything?.riskfactors,
                                [diagnosisName]: riskfactors
                            }
                        }
                    },
                },


                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteActualId) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    riskfactors: {
                                        ...parsedData?.freeTypesEverything?.riskfactors,
                                        [diagnosisName]: riskfactors
                                    }
                                }
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    },[riskfactors,addedThruUseeffect])

    useEffect(() => {
        console.log(patientDBdata?.currentNote?.data, 'patientDBdata?.currentNote?.data')
        const riskFactorsObj = patientDBdata?.currentNote?.data?.riskFactors || ''
        if (riskFactorsObj) {
            // split diagnosis key risk factor
            const riskfactors = riskFactorsObj?.[diagnosisName]?.split(',')
            if (riskfactors?.filter(item => item).length) {
                setRiskfactors(riskfactors?.join(','))
                setTempRiskfactors(riskfactors?.join(','))
            }
        }
    }, [])

    const handleBlur = async() => {
        setPatientDBdata((prev) => {
            return {
                ...prev,
                currentNote: {
                    ...prev?.currentNote,
                    data: {
                        ...prev?.currentNote?.data,
                        freeTypesEverything: {
                            ...prev?.currentNote?.data?.freeTypesEverything,
                            riskfactors:{
                                ...prev?.currentNote?.data?.freeTypesEverything?.riskfactors,
                                [diagnosisName]: tempRiskfactors
                            }
                        }
                    },
                },


                allNotes: prev?.allNotes?.map((note) => {
                    if (note?.id === noteActualId) {
                        const parsedData = note?.data ? JSON.parse(note.data) : {}

                        return {
                            ...note,
                            data: JSON.stringify({
                                ...parsedData,
                                freeTypesEverything: {
                                    ...parsedData?.freeTypesEverything,
                                    riskfactors: {
                                        ...parsedData?.freeTypesEverything?.riskfactors,
                                        [diagnosisName]: tempRiskfactors
                                    }
                                }
                            }),
                        }
                    }
                    return note
                }),
            }
        })
    }

    if(!riskfactors) return

    return (
        <div>
            <p className='p-0 m-0'>Risk Factors</p>
            <GraytextareaAdjustable
            value={tempRiskfactors}
            onBlur={handleBlur}
            onChange={(e) => {
                setTempRiskfactors(e.target.value)
            }}
            />
        </div>
    )
}

export default RiskfactorsFreeTypeRecords